import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import BeSafeTooltip from './BeSafeTooltip';

const BeSafeButton = ({
  visible,
  tooltip,
  tooltipValues = {},
  variant,
  type,
  className,
  onClick,
  disabled,
  href,
  target,
  rel,
  style,
  icon,
  text,
  size,
  iconPosition,
}) => {
  // A disabled button fires no mouse events, so its tooltip needs a wrapper to hover on.
  const wrapForTooltip = disabled && Boolean(tooltip);

  const button = (
    <Button
      variant={variant}
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      href={href}
      target={target}
      rel={rel}
      style={wrapForTooltip ? { ...style, pointerEvents: 'none' } : style}
      size={size}
    >
      {iconPosition === 'left' && icon}
      {text}
      {iconPosition === 'right' && icon}
    </Button>
  );

  return visible ? (
    <BeSafeTooltip
      tooltip={
        tooltip ? <FormattedMessage id={tooltip} values={tooltipValues} /> : ''
      }
    >
      {wrapForTooltip ? <span className="d-inline-block">{button}</span> : button}
    </BeSafeTooltip>
  ) : null;
};

BeSafeButton.defaultProps = {
  visible: true,
  type: 'button',
  iconPosition: 'left',
};
export default BeSafeButton;
